
<template>
  <div class="item-box-content" style="min-height:632px;padding-bottom:30px">
    <div class="title-font-style">
      <span>罚没金开票</span>
    </div>
    <invoice-information ref="invoiceInformationRefs" v-show="isShow" @getList="getList"></invoice-information>
    <div style="padding:20px 30px 0" v-show="!isShow">
      <el-table border :data="[queryParams]" tooltip-effect="dark" :header-cell-style="tableHeader">
        <el-table-column label="开票编号" width="140" prop="invoiceNumber">
        </el-table-column>
        <el-table-column label="公司名称" prop="cusName" show-overflow-tooltip></el-table-column>
        <el-table-column label="发票金额">
          <template slot-scope="scope">{{scope.row.amount|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="税额">
          <template slot-scope="scope">{{scope.row.taxAmount|priceFilterNum}}</template>
        </el-table-column>
        <el-table-column label="申请时间" width="132">
          <template slot-scope="scope">{{scope.row.createDate|dateFilter}}</template>
        </el-table-column>
        <el-table-column label="发票类型" prop="invoiceType"></el-table-column>
        <el-table-column label="开票类型" prop="bilingType"></el-table-column>
        <el-table-column label="开票状态" width="84">
          <template
            slot-scope="scope"
          >{{scope.row.state===1?'开票审核':scope.row.state===2?'已开票 ':'审核不通过'}}</template>
        </el-table-column>
        <el-table-column label="发票编号" show-overflow-tooltip prop="invoiceCode"></el-table-column>
        <el-table-column label="处理人" prop="processSecUser"></el-table-column>
        <el-table-column label="开票时间" width="132">
          <template slot-scope="scope">{{scope.row.invoiceDate|dateFilter}}</template>
        </el-table-column>
      </el-table>
      <el-steps
        :active="queryParams.state===3?3:queryParams.state+1"
        style="width:85%;margin:30px auto;"
        align-center
        class="mainStep"
      >
        <el-step
          :title="item"
          v-for="(item, i) in stepList"
          :key="i"
          :icon="item==='审批不通过'?'':'el-icon-success'"
          :status="item==='审批不通过'?'error':''"
        ></el-step>
      </el-steps>
      <el-form class="details-line-height" v-show="queryParams.state===3">
        <el-row>
          <el-col :span="12">
            <el-form-item label="处理人：">{{queryParams.processSecUser}}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="处理时间：">{{queryParams.processSecDate|dateFilter}}</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注：">{{queryParams.invoiceMark}}</el-form-item>
          </el-col>
        </el-row>
        <el-button type="primary" @click="onInvoice">重新申请</el-button>
      </el-form>
    </div>
  </div>
</template>
<script>
import invoiceInformation from './invoiceInformation'
import {
  forfeitureInvoice,
  forfeitureInvoiceDetail,
  forfeitureInvoiceReCommit
} from '@/api/sell/sellManage'
export default {
  components: {
    'invoice-information': invoiceInformation
  },
  data() {
    return {
      queryParams: {},
      stepList: ['开票申请', '开票审批', '开票成功'],
      isShow: true
    }
  },
  methods: {
    getList(id, val, type) {
      if (val === 1) {
        this.isShow = true
        forfeitureInvoice(this.$route.query.id, id).then((res) => {
          if (res.data.code === 200) {
            this.$refs.invoiceInformationRefs.init(res.data.obj)
          }
        })
      } else {
        this.isShow = false
        forfeitureInvoiceDetail(this.$route.query.id, id).then((res) => {
          if (res.data.code === 200) {
            this.queryParams = res.data.obj
            this.queryParams.ocbId = id
            this.stepList[2] =
              res.data.obj.state === 3 ? '审批不通过' : '开票成功'
          }
        })
        if (type) {
          this.$emit('onSuccess')
        }
      }
    },
    onInvoice() {
      forfeitureInvoiceReCommit(
        this.$route.query.id,
        this.queryParams.ocbId,
        this.queryParams.id
      ).then((res) => {
        if (res.data.code === 200) {
          this.$refs.invoiceInformationRefs.init(res.data.obj)
          this.isShow = true
        }
      })
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
